/**
 * Sign Up With Firebase
 */
import React, { Component } from 'react';
import Button from '@mui/material/Button';
import { connect } from 'react-redux';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Link } from 'react-router-dom'; 
import LinearProgress from '@mui/material/LinearProgress';
import QueueAnim from 'rc-queue-anim';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {decode as base64_decode} from 'base-64';
import CircularProgress from '@mui/material/CircularProgress';
import {
	FormGroup,
	Label,
	
} from 'reactstrap';
// components
import { SessionSlider } from 'Components/Widgets';

// app config
import AppConfig from 'Constants/AppConfig';

// redux action
import {
   fetchParentDetails,
   addRegisterForm,
} from 'Actions';
import withRouter from 'Util/withRouter';


class SignupFirebase extends Component {

   state = {
      stdfirstname: '',
      stdlastname:'',
      stdemail: '',
      stdmobile: '',  
      prntname:'',
      prntemail:'',
      seldate:'',
      selage:'',
      pid:'',
      stdid:'',
      loader:false,
   }

   componentDidMount() {
      let {id} = this.props.params;      
      let urlid=base64_decode(id);
      if(urlid!=0){
         this.props.fetchParentDetails(urlid).then((data) => { 
            var resdata=data.data;
            var contract=resdata.contract;
            var student=resdata.student;

            if(contract[0].cts_studentid==0){
                  this.setState({ 
                     stdfirstname:contract[0].cts_studentname,
                     stdlastname:contract[0].cts_studentlname
                  });
            }

            this.setState({ 
               pid:urlid,
               prntname:contract[0].cts_parentname,
               prntemail:contract[0].cts_parentemail
            });

            if(contract[0].cts_studentid!=0){

               this.setState({
                     stdid:student[0].uudID, 
                     stdfirstname:student[0].uud_firstName,
                     stdlastname:student[0].uud_lastName,
                     stdemail:student[0].uud_email,
                     stdmobile:student[0].uud_phone,
                     seldate:student[0].uud_dob=='0000-00-00'? '':new Date(student[0].uud_dob)
               });  

            }

         });
      }      
   }

	

   selectdate = (date) => {
      const seldate =moment(new Date(date)).format('yyyy-MM-DD');
      this.setState({ seldate:date });        
   }
   
   selectage = (date) => {
      const seldate =moment(new Date(date)).format('yyyy-MM-DD');
      this.setState({ selage:date });        
   }

   addHandleSubmit(event){
      event.preventDefault();
      var stdmobile=event.target.stdmobile.value;
      var stdemail=event.target.stdemail.value;
      var prtemail=event.target.prntemail.value;
      var prtmobile=event.target.prntmobile.value;

      if(stdmobile==prtmobile){
         alert('Student mobile and Parent mobile number should not be same.');         
      }else if(stdemail==prtemail){
         alert('Student email and Parent email should not be same.');         
      }else{
         this.setState({loader:true });  
         let { pid, stdid } =this.state;
         this.props.addRegisterForm(event, pid, stdid).then((data) => {   
            this.setState({loader:false });            
         });
      }
   }

   render() {
      const { loading } = this.props;
      const styles = {
         buttonProgress: {
             color: "orange",
             position: 'absolute',
             top: '50%',
             left: '50%',
             marginTop: -15,
             marginLeft: -15,
         },
         wrapper: {
             position: 'relative',
         },
     };
      return (
         <QueueAnim type="bottom" duration={2000}>
            <div className="rct-session-wrapper">
               {loading &&
                  <LinearProgress />
               }
               <AppBar position="static" className="session-header">
                  <Toolbar>
                     <div className="container">
                        <div className="d-flex justify-content-between">
                           <div className="session-logo">
                              <Link to="/">
                                 <img src={AppConfig.appLogo} alt="session-logo" width="110" height="35" />
                              </Link>
                           </div>
                           <div>
                              <Link to="/signin" className="mr-15 text-white">Already have an account?</Link>
                              <Button
                                 component={Link}
                                 to="/signin"
                                 variant="contained"
                                 className="btn-light"
                              >
                                 Sign In
										</Button>
                           </div>
                        </div>
                     </div>
                  </Toolbar>
               </AppBar>
               <div className="session-inner-wrapper">
                  <div className="container">
                     <div className="row row-eq-height">
                        <div className="col-sm-10 col-md-10 col-lg-10" style={{margin:"0 auto"}}>
                           <div className="session-body text-center">
                              <div className="session-head mb-15">
                                 <h2>Get started with {AppConfig.brandName}</h2>
                              </div>
                              <form autoComplete="off" id="addform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                                 <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                       <div className="dsds">
                                       <h2>Student Details:</h2>
                                       <FormGroup>
                                          <input type="text" name="stdfirstname" id="stdfirstname" value={this.state.stdfirstname} onChange={e => this.setState({ stdfirstname:e.target.value })} className="form-control form-control-alternative" placeholder="Student First Name" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup> 
                                       <FormGroup>
                                          <input type="text" name="stdlastname" id="stdlastname" value={this.state.stdlastname} onChange={e => this.setState({ stdlastname:e.target.value })} className="form-control form-control-alternative" placeholder="Student Last Name" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup> 
                                       <FormGroup>
                                          <input type="text" name="stdemail" id="stdemail" value={this.state.stdemail} onChange={e => this.setState({ stdemail:e.target.value })} className="form-control form-control-alternative" placeholder="Student Email" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup> 
                                       <FormGroup>
                                          <input type="text" name="stdmobile" id="stdmobile" value={this.state.stdmobile} onChange={e => this.setState({ stdmobile:e.target.value })} className="form-control form-control-alternative" placeholder="Student Mobile" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup>
                                       <FormGroup>
                                       <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" placeholderText="Student Date of Birth" required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        selectsEnd
                                                        maxDate={new Date()} 
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        style={{ backgroundColor: '#EDF0FF' }}
                                                    /> 
                                       </FormGroup>  
                                       <FormGroup>
                                          <input type="text" name="stdblood" id="stdblood" className="form-control form-control-alternative" placeholder="Student Blood Group" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup>
                                       <FormGroup>
                                          <input type="text" name="stdfood" id="stdfood" className="form-control form-control-alternative" placeholder="Student Food Preference" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup>
                                       <FormGroup>
                                          <input type="text" name="stdallergies" id="stdallergies" className="form-control form-control-alternative" placeholder="Student Food Allergies" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup>
                                       <FormGroup>
                                          <input type="text" name="stdmedical" id="stdmedical" className="form-control form-control-alternative" placeholder="Student Medical Condition" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup>
                                       <FormGroup>
                                       <textarea rows="3" type="text" name="stdothers" id="stdothers" className="form-control form-control-alternative" placeholder="Other Information" style={{ backgroundColor: '#EDF0FF' }} required></textarea>
                                       </FormGroup>
                                       </div>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                    <div className="dsds">
                                       <h2>Parent Details:</h2>
                                       <FormGroup>
                                          <input type="text" name="prntname" id="prntname" value={this.state.prntname} onChange={e => this.setState({ prntname:e.target.value })} className="form-control form-control-alternative" placeholder="Parent Name" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup>
                                       <FormGroup>
                                          <input type="text" name="prntemail" id="prntemail" value={this.state.prntemail} onChange={e => this.setState({ prntemail:e.target.value })} className="form-control form-control-alternative" placeholder="Parent Email" style={{ backgroundColor: '#EDF0FF' }} disabled required/>
                                       </FormGroup>
                                       <FormGroup>
                                          <input type="text" name="prntmobile" id="prntmobile" className="form-control form-control-alternative" placeholder="Parent Mobile" style={{ backgroundColor: '#EDF0FF' }} required/>
                                       </FormGroup> 
                                       <FormGroup>
                                       <DatePicker className="form-control" id="selectage"  name="selectage" autoComplete="off" placeholderText="Parent Age" required
                                                        selected={this.state.selage}
                                                        onChange={this.selectage}
                                                        dateFormat='yyyy-MM-dd'
                                                        selectsEnd
                                                        maxDate={new Date()} 
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                        style={{ backgroundColor: '#EDF0FF' }}
                                                    />
                                       </FormGroup> 
                                       <FormGroup>
                                       <textarea rows="3" type="text" name="address" id="address" className="form-control form-control-alternative" placeholder="Address" style={{ backgroundColor: '#EDF0FF' }} required></textarea>
                                       </FormGroup> 
                                      </div> 
                                    </div>
                                    <div className="col-md-12">
                                        <div className="form-group"> 
                                             <div className="ddd" style={styles.wrapper}>
                                             <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" disabled={this.state.loader}>Register</button> 
                                             {this.state.loader && <CircularProgress size={24} style={styles.buttonProgress} />}
                                             </div>
                                            {/* <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Register" />      */}
                                        </div>
                                    </div>
                                 </div>
                              </form>                             
                           </div>
                        </div>
                        
                     </div>
                  </div>
               </div>
            </div>
         </QueueAnim>
      );
   }
}

// map state to props
const mapStateToProps = ({ authUser }) => {
   const { loading } = authUser;
   return { loading };
};

export default withRouter(connect(mapStateToProps, {
   fetchParentDetails,
   addRegisterForm
})(SignupFirebase));
